import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/outsourced/employees/page.tsx");
